import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareListCustomEmbedClassicRoute: InvariantJiraRoute = {
	name: 'software-list-classic-custom-embed',
	path: '/jira/software/c/projects/:projectKey/list/:navigationItemId/embed',
};
